import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m35.5 34v-18c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v18c0 4.69-3.81 8.5-8.5 8.5s-8.5-3.81-8.5-8.5v-23c0-3.03 2.47-5.5 5.5-5.5s5.5 2.47 5.5 5.5v21.5c0 1.38-1.12 2.5-2.5 2.5s-2.5-1.12-2.5-2.5v-19.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v19.5c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5v-21.5c0-4.69-3.81-8.5-8.5-8.5s-8.5 3.81-8.5 8.5v23c0 6.34 5.16 11.5 11.5 11.5s11.5-5.16 11.5-11.5z" })
});
export default SvgFileUpload;
